import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Radio,
  RadioGroup,
  Stack,
  Button,
} from "@chakra-ui/react";

const ShareOpinionModal = ({ isOpen, onClose, onSubmit = () => {} }) => {
  const [selectedOption, setSelectedOption] = useState("MO");
  const handleShare = () => {
    onSubmit(selectedOption);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          Share Opinion
        </ModalHeader>
        <ModalBody>
          <RadioGroup value={selectedOption} onChange={setSelectedOption}>
            <Stack spacing={4}>
              <Radio value="MO">Medical Opinion</Radio>
              <Radio value="AL">Appointment Letter</Radio>
              <Radio value="ALL">Both</Radio>
            </Stack>
          </RadioGroup>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleShare}>
            Share
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ShareOpinionModal;
